function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
function normalizePath(path) {
    if (!path)
        return "";
    return path.startsWith("/") ? path : `/${path}`;
}
async function safeReadResponseText(response) {
    try {
        return await response.text();
    }
    catch {
        return "";
    }
}
export class BackendClientBase {
    constructor(options) {
        this.getBaseUrl = options.getBaseUrl;
        this.getAuthHeader = options.getAuthHeader;
        this.serviceName = options.serviceName || "BackendClientBase";
        this.defaultHeaders = options.defaultHeaders || {};
        this.maxRetries = Math.max(0, options.maxRetries ?? 1);
        this.retryDelayMs = Math.max(0, options.retryDelayMs ?? 250);
    }
    resolveBaseUrl() {
        const baseUrl = this.getBaseUrl();
        return baseUrl.replace(/\/+$/, "");
    }
    async request(path, init = {}, options = {}) {
        const retries = options.retries ?? this.maxRetries;
        const requireAuth = options.requireAuth ?? false;
        let attempt = 0;
        while (true) {
            attempt += 1;
            try {
                const authHeader = this.getAuthHeader ? await this.getAuthHeader() : undefined;
                if (requireAuth && !authHeader) {
                    throw new Error("Not authenticated. Please login first.");
                }
                const headers = {
                    ...this.defaultHeaders,
                    ...init.headers,
                    ...(authHeader ? { Authorization: authHeader } : {}),
                };
                const response = await fetch(`${this.resolveBaseUrl()}${normalizePath(path)}`, {
                    ...init,
                    headers,
                });
                if (!response.ok) {
                    const responseText = await safeReadResponseText(response);
                    throw new Error(`${this.serviceName}: request failed (${response.status}) ${responseText || response.statusText}`);
                }
                return response;
            }
            catch (error) {
                if (attempt > retries) {
                    throw error;
                }
                await delay(this.retryDelayMs * attempt);
            }
        }
    }
    async requestJson(path, init = {}, options = {}) {
        const response = await this.request(path, init, options);
        return (await response.json());
    }
}
